import { isEqual, pick } from 'lodash';

const PREVIEW_FIELDS = [
    'title',
    'description',
    'rubric',
    'citation_format',
    'content_bank_resources',
    'ai_grading_enabled',
    'ai_grading_settings',
    'ai_grading_context',
    'ai_feedback_enabled',
    'ai_feedback_settings',
    'ai_feedback_context',
    'ai_inline_comments_enabled',
    'ai_inline_comments_settings',
    'ai_inline_comments_context',
];

const FORMATIVE_FIELDS = [
    ...PREVIEW_FIELDS.slice(0, 11),
    'ai_student_feedback_enabled',
    'ai_student_feedback_settings',
    'ai_student_feedback_context',
];

const hasChanged = (previous, next, fields) => !isEqual(pick(previous, fields), pick(next, fields));

export const shouldInvalidatePreview = (previous, next) =>
    !previous?.has_finished_preview && hasChanged(previous, next, PREVIEW_FIELDS);

export const shouldInvalidateFormative = (previous, next) =>
    !previous?.has_finished_formative && hasChanged(previous, next, FORMATIVE_FIELDS);
